import { useMemo } from "react";

/**
 * Utility function to check if the user has the "EMP_NONVEHECOMMERCE_PARTSONLY" role
 * Can be used in both class and function components
 *
 * @param {Object} user - The user object containing roles
 * @returns {boolean} - True if user has the parts-only role, false otherwise
 */
export const hasPartsOnlyRole = (user) => {
  if (!user?.roles) {
    return false;
  }

  // Check if roles is an array
  if (Array.isArray(user.roles)) {
    return (
      user.roles.length === 1 &&
      user.roles[0] === "EMP_NONVEHECOMMERCE_PARTSONLY"
    );
  }

  // Check if roles is an object (check values)
  if (typeof user.roles === "object") {
    const roleValues = Object.values(user.roles);
    return (
      roleValues.length === 1 &&
      roleValues[0] === "EMP_NONVEHECOMMERCE_PARTSONLY"
    );
  }

  return false;
};

/**
 * Custom hook to check if the user has the "EMP_NONVEHECOMMERCE_PARTSONLY" role
 * For use in function components
 *
 * @param {Object} user - The user object containing roles
 * @returns {boolean} - True if user has the parts-only role, false otherwise
 */
export const usePartsOnlyRole = (user) => {
  return useMemo(() => hasPartsOnlyRole(user), [user]);
};

export default usePartsOnlyRole;
